import React, { useState } from 'react'
import { Box, Divider } from '@mui/material'
import styled from '@emotion/styled'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next';

const ActiveTag = styled(Box)`
    border-bottom: ${props => props.active == 'true' ? '3px solid #35F8FF' : 'null'};
    font-weight: 500;
    color:#FEFFFF;
    line-height:24px;
    fontsize:56px;
    cursor: pointer;
    ${props => props.styles}
`

const initialState = [
    {
        name: 'NFTs',
        active: true,
        number: 1,
    },
    {
        name: 'Description',
        active: false,
        number: 2,
    },
    {
        name: 'Activity',
        active: false,
        number: 3,
    }
]

const options = [
    {
        name: 'Date Minted - Newest',
        value: 'newest'
    },
    {
        name: 'Date Minted - Oldest',
        value: 'oldest'
    },
    {
        name: 'Price - Highest',
        value: 'highest'
    },
    {
        name: 'Price - Lowest',
        value: 'lowest'
    }
]


/**
 * It's a function that takes in an array of objects, and returns a list of buttons that when clicked,
 * will update the state of the parent component.
 * @param {Array} items - An array of objects that will be used to render the buttons.
 * @param {Function} setUpdate - A function that will be used to update the state of the parent component.
 * @returns The return is a component that is being rendered.
 */
const TabSelector = ({items, setUpdate, activeTab}) => {
    const { t } = useTranslation("translate")
    const [tabs, setTabs] = useState(items)
    const handleClickActiveTab = (index) => {
        const newTabs = [...tabs]
        newTabs.forEach((tab, i) => {
            if(i === index){
                setUpdate(tab.number)
                setTabs([...tabs.map((tab, i) => {
                    if(i === index){
                        return {...tab, active: true}
                    }
                    return {...tab, active: false}
                })])
            }
        })
    }

    React.useEffect(() => {
        let arr = items.map((item) => {
            return {...item, active:item.number==activeTab?true:false}
        });
        setTabs(arr)
    },[t])

    return (
        <>
            <Box
                sx={{
                    width:'100%'
                }}
            >
                <Box display='flex' justifyContent='space-between' 
                    sx={{
                        width: '100%',

                        "@media (max-width: 768px)": {
                            display:'grid',
                            width:'100%',
                            gridTemplateColumns:'1fr',
                        }
                    }}
                >
                    
                    <Box display='flex' justifyContent='flex-start' 
                        sx={{
                            gap:'1rem',
                            marginLeft:'1.5rem',
                            "@media (max-width: 768px)": {
                                width:'100%',
                                justifyContent:'flex-start',
                            },
                            fontFamily:'BentonSansBBVA-Medium,sans-serif'
                        }}>
                        {tabs.map((item, index) => 
                        <ActiveTag key={index} onClick={()=>handleClickActiveTab(index)} active={item.active+''}>{item.name}</ActiveTag>)}
                    </Box>       
                </Box>
                <Divider sx={{backgroundColor:'rgba(21, 21, 21, 0.4)'}}/>
            </Box>
        </>
    )
}

TabSelector.defaultProps = {
    items: initialState,
    showSelector: true,
    options: options,
    setUpdate: () => {}
}

TabSelector.propTypes = {
    items: PropTypes.array,
    setUpdate: PropTypes.func,
    options: PropTypes.array,
    showSelector: PropTypes.bool,
    activeTab: PropTypes.number
}

export default TabSelector

